




























































































































import { getConfig } from '@superbet-group/web.lib.config';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import {
    SdsLink,
    SdsButtonText,
    SdsIcon,
} from '@superbet-group/web.lib.ui-components';
import { defineComponent } from '@vue/composition-api';

import { shellLocalConfig } from '@src/config/shell/localConfig';
import helpUiStoreIndex from '@store/modules/ui/help/helpIndex';

import FooterColumnsTitle from './FooterColumnsTitle.vue';
import shouldOpenWApp from '@modules/layout/utils/shouldOpenWApp';
import { isMobileDevice } from '@src/app/utils/browser/deviceType';

export default defineComponent({
    name: 'Help',
    setup() {
        const config = getConfig();
        const footerLocalConfig = shellLocalConfig.footer;
        const helpUiStore = useVuexStore<typeof helpUiStoreIndex>('ui/help');
        const isEmailContactVisible = shellLocalConfig.isEmailContactShown;
        const isContactFormShown = !!shellLocalConfig.footerContactFormUrl;

        const showHelp = helpUiStore.action('showHelp');

        const viberDeepLink = `viber://contact?number=${footerLocalConfig.viberNumber.replace(/\s/g, '').replace('+', '%2B')}`;

        const shouldDisplaySupportNumbers = () => {
            return config.countrySpecific.footer.whatsAppNumber || footerLocalConfig.viberNumber || config.countrySpecific.footer.nonStopPhoneNumber;
        };

        const maybeOpenWapp = () => {
            shouldOpenWApp(isMobileDevice);
        };

        const email = getConfig().countrySpecific.footer.email;
        return {
            footerConfig: config.countrySpecific.footer,
            footerLocalConfig,
            viberDeepLink,
            showHelp,
            shouldDisplaySupportNumbers,
            maybeOpenWapp,
            email: email.startsWith('http')
                ? email
                : `mailto:${email}`,
            isEmailContactVisible,
            isContactFormShown,
            contactFormUrl: shellLocalConfig.footerContactFormUrl,
        };
    },
    components: {
        FooterColumnsTitle,
        SdsLink,
        SdsButtonText,
        SdsIcon,
    },
});
